export default __webpack_public_path__ + "static/cs-2-c76da73750f5b3a63689d1d94daef446.png";